// Forensic Audit Standard. Shared by the performance record and the
// Case Studies archive so both pages describe verification identically.

export const AUDIT_PILLARS = [
  {
    code: "01",
    title: "Server ledger at decision time",
    body: "The engine writes each decision to the desk database when the execution candle closes, before price reaches any target. Entry time is the server record, not a later screenshot.",
  },
  {
    code: "02",
    title: "Fixed geometry from the first bar",
    body: "Entry, stop, TP1 and TP2 are stored once. The only permitted change is the rule based move of the stop to break even after TP1. Losing positions stay in the archive.",
  },
  {
    code: "03",
    title: "Results counted in R",
    body: "Each outcome is a multiple of the initial risk, so position size cannot inflate a result. Half closes at TP1 and the remainder at TP2 or break even, both counted.",
  },
  {
    code: "04",
    title: "M5 tape reconstruction",
    body: "Every closed position links to a candle by candle replay built from stored five minute XAUUSD bars, from entry to the exact bar that resolved it.",
  },
] as const

export const AUDIT_METHOD =
  "Automated server ledger with fixed stop and target geometry, outcomes in R multiples, verified by M5 bar replay of stored XAUUSD data."

export function AuditStandard() {
  return (
    <section aria-labelledby="audit-standard" className="border-b border-border">
      <div className="container mx-auto max-w-7xl px-4 py-10">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
          Forensic Audit Standard
        </div>
        <h2 id="audit-standard" className="mt-2 font-display text-xl font-bold sm:text-2xl">
          How each XAUUSD position is recorded and checked
        </h2>
        <ol className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {AUDIT_PILLARS.map((p) => (
            <li key={p.code} className="rounded-lg border border-border bg-card p-4">
              <div className="font-mono text-xs text-primary">{p.code}</div>
              <h3 className="mt-2 text-sm font-semibold">{p.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{p.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
